module.exports = "\n<div class=\"well well-nothing well-field\">\n  <a href=\"#\" ng-click=\"onUpgradeClick()\">{{ upgradePrompt }}</a>\n</div>\n";